import { getPairedDevicesArr } from "./selectors";
import Presence from "src/constants/presence";

export default function getAvailableStations(state) {
  const pairedDevices = getPairedDevicesArr(state);
  const availableDevices = pairedDevices.filter(
    (device) =>
      device.status === Presence.SENDER ||
      device.status === Presence.SENDER_CONNECTED
  );
  return availableDevices;
}
